import {atom, useRecoilState} from 'recoil';
import {ethers, providers} from 'ethers';


export const metamaskState = atom({
  key: 'metamaskState',
  dangerouslyAllowMutability: true,
  default: {
    provider: undefined,
    signer: undefined,
    account: undefined,
  },
});

/**
 * A hook to provide Metamask's 'connect' function anywhere, and give global access to the
 * returned values (user's account, provider, signer).
 * - As this uses recoil state, consumers can use an effect to change UI/perform other functions
 *   when a user connects
 */
export const useMetamask = (network = 'any') => {
  const [state, setState] = useRecoilState(metamaskState);

  const connect = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum, network);
    await provider.send('eth_requestAccounts', []);

    provider.on('network', (_, oldNetwork) => {
      oldNetwork && window.location.reload();
    });

    const signer = await provider.getSigner();
    const account = await signer.getAddress();
    setState({provider, signer, account});

    return {
      account,
      provider,
      signer,
    };
  };

  return {
    ...state,
    connect,
  };
};